import React, { useContext, useState } from "react";
import { Fab, Typography, Grid, TextField } from "@material-ui/core";
import useReactRouter from "use-react-router";
import { LangContext } from "../../Context/Langcontext";
import { makeStyles } from "@material-ui/styles";
import { MdEmail } from "react-icons/md";
import clsx from "clsx";
import { getForgotPassword } from "../../API/Auth";
import { useSnackbar } from "notistack";

const useStyle = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      padding: "4rem 2rem 0px",
    },
    [theme.breakpoints.up("md")]: {
      padding: "5rem 5rem 0px",
    },
  },
  focusIcon: {
    color: theme.palette.primary.main,
  },
  blurIcon: {
    color: "rgba(0,0,0,0.5)",
  },
  formControl: {
    width: "100%",
    "& .MuiFormLabel-root": {
      color: theme.palette.main,
    },
    "& label.Mui-focused": {
      color: theme.palette.main,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette.main,
    },
    "& .MuiOutlinedInput-root": {
      fontWeight: 200,
      "& fieldset": {
        borderColor: theme.palette.main,
        borderRadius: `3rem`,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.main,
      },
    },
    "& .MuiOutlinedInput-inputAdornedStart": {
      paddingLeft: 10,
    },
  },
}));

const Resetpassword = ({ setpage }) => {
  const classes = useStyle();
  const { history } = useReactRouter();
  const langContext = useContext(LangContext);
  const [state, setstate] = useState({ email: "" });
  const lang = langContext.lang.data;
  const { enqueueSnackbar } = useSnackbar();
  const [process, setProcess] = useState(true);
  const [focusIcon, setFocusIcon] = useState({
    email: false,
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    const input = {
      email: state.email,
    };
    setProcess(true);
    const forgot = await getForgotPassword(input);
    if (forgot.status.code === 200) {
      setProcess(false);
      history.replace("/user/login");
      enqueueSnackbar(lang.CheckEmail, {
        variant: "success",
      });
    } else {
      setProcess(false);
      enqueueSnackbar(forgot.status.message, {
        variant: "error",
      });
    }
  };
  return (
    <div className={classes.root}>
      <Typography
        variant="h5"
        component="p"
        style={{ fontWeight: 600, padding: "1rem 0rem" }}
      >
        {lang.ForgotPassword}
      </Typography>
      <Typography
        variant="h6"
        component="p"
        style={{ fontWeight: 200, paddingBottom: "1rem" }}
      >
        {lang.EnterEmail}
      </Typography>
      <div>
        <form onSubmit={onSubmit}>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                id="login-input-email"
                label={lang.Email}
                name="Email"
                type="email"
                value={state.email}
                variant="outlined"
                className={classes.formControl}
                classes={{ root: classes.textFieldColour }}
                onChange={(e) => {
                  setstate({ ...state, email: e.target.value });
                  setProcess(false);
                }}
                required
                onFocus={(e) => {
                  setFocusIcon({ ...focusIcon, email: true });
                }}
                onBlur={(e) => {
                  setFocusIcon({ ...focusIcon, email: false });
                }}
                InputProps={{
                  className: classes.input,

                  startAdornment: (
                    <MdEmail
                      size={28}
                      className={clsx(
                        focusIcon.email ? classes.focusIcon : classes.blurIcon
                      )}
                    />
                  ),
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "1rem",
            }}
          >
            <Fab
              variant="extended"
              aria-label="signin"
              color="secondary"
              style={{ boxShadow: "unset" }}
              onClick={() => {
                setpage(0);
                history.push("/user/login");
              }}
            >
              <Typography variant="h6" component="p" style={{ color: "white" }}>
                {lang.Cancel}
              </Typography>
            </Fab>

            <Fab
              variant="extended"
              aria-label="signin"
              color="primary"
              type="submit"
              disabled={process}
              style={{ boxShadow: "unset", textTransform: "unset" }}
              // onClick={() => {
              //   Nextstate();
              // }}
            >
              <Typography variant="h6" component="p" style={{ color: "white" }}>
                {lang.SendEmail}
              </Typography>
            </Fab>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Resetpassword;
